import TableOpenCodes from '../components/TableOpenCodes';

const Home = () => (
  <div>
    <TableOpenCodes />
  </div>
);

export default Home;
